import { render, staticRenderFns } from "./OrderSalaryDetailDialog.vue?vue&type=template&id=ec6d8b58&scoped=true"
import script from "./OrderSalaryDetailDialog.vue?vue&type=script&lang=js"
export * from "./OrderSalaryDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderSalaryDetailDialog.vue?vue&type=style&index=0&id=ec6d8b58&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6d8b58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec6d8b58')) {
      api.createRecord('ec6d8b58', component.options)
    } else {
      api.reload('ec6d8b58', component.options)
    }
    module.hot.accept("./OrderSalaryDetailDialog.vue?vue&type=template&id=ec6d8b58&scoped=true", function () {
      api.rerender('ec6d8b58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/OrderSalaryDetailDialog.vue"
export default component.exports